import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Kobi-Line | Yönetim Girişi";
  }, []);

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("kbl_admin_token", data.token);
      navigate("/admin/panel");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    "w-full rounded-xl border border-[#E2E8F0] bg-white px-4 py-3 text-sm text-[#0F172A] placeholder:text-[#94A3B8] outline-none transition-all focus:border-[#0000FF] focus:ring-4 focus:ring-[#0000FF]/10";

  return (
    <div className="min-h-screen bg-[#0B192C] hero-grid-bg flex items-center justify-center px-4" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 32, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md bg-white rounded-3xl p-8 sm:p-10 shadow-2xl"
      >
        <div className="flex items-center gap-2.5 mb-8">
          <img src="/logo-horse.png" alt="Kobi-Line" className="w-10 h-10 rounded-xl object-cover" />
          <div>
            <p className="font-display font-bold text-lg text-[#0F172A] leading-tight">KOBİ-LİNE</p>
            <p className="text-xs text-[#94A3B8]">Yönetim Paneli</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-sm font-semibold text-[#0F172A] mb-2">E-posta</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@kobiline.com"
              className={inputClass}
              data-testid="admin-email-input"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-[#0F172A] mb-2">Şifre</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className={inputClass}
              data-testid="admin-password-input"
              required
            />
          </div>
          {error && (
            <p className="text-sm font-medium text-red-500" data-testid="admin-login-error">{error}</p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-button"
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#0F172A] text-white font-semibold px-7 py-3.5 transition-colors hover:bg-[#0000FF] disabled:opacity-60"
          >
            {loading ? <Loader2 size={18} className="animate-spin" /> : <Lock size={16} />}
            Giriş Yap
          </button>
        </form>
        <a href="/" data-testid="back-to-site-link" className="block text-center mt-6 text-xs text-[#94A3B8] hover:text-[#0000FF] transition-colors">
          ← Siteye geri dön
        </a>
      </motion.div>
    </div>
  );
}
